import React from 'react';
import PropTypes from 'prop-types';

const CheckBox = (props) => {
  const { options, label, readOnly, handleEvent } = props;
  const handleCheckboxEvent = (e) => {
    handleEvent({ [props.name]: e.target.selected });
  };
  
  return (
    <>
    <div>
      <h5>{label}</h5>
      <se-checkbox-group
        data-testid='checkbox'
        direction='row'
      >
        {
          options?.map((option) => {
            return (
              <se-checkbox
                key={option.key}
                selected={option.checked}
                data-testid='checkbox'
                name={option.name}
                label={option.label}
                style={{ marginInline: '10px' }}
                disabled={readOnly}
                onClick={() => handleCheckboxEvent(option.name)}
              ></se-checkbox>
            )
          })
        }
      </se-checkbox-group>
    </div>
    </>
  );
};

export default CheckBox;

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handleCheckboxEvent: PropTypes.func,
  label: PropTypes.string.isRequired,
  option: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  handleEvent: PropTypes.func,
};
